import { render, staticRenderFns } from "./progressing-table.vue?vue&type=template&id=2b46c7ba"
import script from "./progressing-table.vue?vue&type=script&lang=js"
export * from "./progressing-table.vue?vue&type=script&lang=js"
import style0 from "./progressing-table.vue?vue&type=style&index=0&id=2b46c7ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports